import { ActivityFootnote, StudyEntityType, toActivityFootnote } from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { ScheduleOfActivitiesQueryParameter, StudyPathParameter, VariantQueryParameter } from '../parameter';

const factory = createStudyEntityHookFactory<ActivityFootnote>(StudyEntityType.ActivityFootnote);

export const useActivityFootnotes = factory.list(
    (
        { studyId, ...query }: ScheduleOfActivitiesQueryParameter & VariantQueryParameter & StudyPathParameter,
        signal?: AbortSignal
    ): Promise<ActivityFootnote[]> => {
        return axios
            .get(`/api/study-designer/studies/${studyId}/footnotes`, {
                signal,
                params: query,
            })
            .then(response => response.data?.map(toActivityFootnote) ?? []);
    }
);
export const useActivityFootnoteInsert = factory.mutate((entity: ActivityFootnote) => {
    return axios
        .post(`/api/study-designer/studies/${entity.studyId}/footnotes`, entity)
        .then(response => response.data);
});
export const useActivityFootnoteUpdate = factory.mutate(
    (entity: ActivityFootnote) => {
        return axios
            .put(`/api/study-designer/studies/${entity.studyId}/footnotes/${entity.id}`, entity)
            .then(response => response.data);
    },
    {
        optimisticUpdate: (footnote, optimisticData) => {
            return optimisticData.map(x => (x.id === footnote.id ? footnote : x));
        },
    }
);
